





























































































import Vue from 'vue';
import LearningTools from '@/tools/learning';
import BbTools from '@/tools/bluebird';
import Activity from '@/components/activity/Activity.vue';
import ActivityStatus from '@/components/activity/ActivityStatusText.vue';
import AccessibleButton from '@/components/ui/AccessibleButton.vue';
import BottomScores from '@/components/activity/BottomScores.vue';
import { QuizPhrase, QuizSpellingLetter, RapidTestResponse } from '@/store/types';

export default Vue.extend({
  components: {
    activity: Activity,
    'accessible-button': AccessibleButton,
    'activity-status': ActivityStatus,
    'bottom-scores': BottomScores,
  },
  props: {
    videoPlayer: Object as () => any,
    nativePhrasesMode: Boolean,
    quizPhrase: Object as () => QuizPhrase,
    activityIndex: Number,
    activityDataLength: Number,
    averageScore: Number,
    isRapidTest: Boolean,
  },
  data() {
    return {
      timeouts: [],
      letters: new Array<QuizSpellingLetter>(),
      letterPenalty: 0,
      currentLetter: 0,
      currentScore: 100,
      spellingPhrase: '',
      quizPhraseCurrent: this.quizPhrase,
      lockInput: false,
      nextQuestionResponse: null as RapidTestResponse | null,
      rapidTestQuizAnswer: new Array<string>(),
    };
  },
  mounted() {
    this.letterPenalty = 0;
    this.currentScore = 100;
  },
  computed: {
    wordCompleted(): boolean {
      if (this.isRapidTest) {
        return this.nextQuestionResponse && this.nextQuestionResponse.data?.question;
      }
      return this.currentLetter === this.quizPhraseCurrent.phraseAnswer.length;
    },
    letterStyle(): string {
      let result = 'padding: 2px; min-width: 30px; text-transform: none; font-size: ';
      result += this.$vuetify.breakpoint.xs ? '14px;' : '18px;';
      return result;
    },
  },
  methods: {
    onPhoneticModeChanged() {
      (this.$refs.activity as any).stopActivity();
      (this.$refs.activity as any).setActivityReady(null, false);
    },
    activityReady() {
      this.currentScore = 100;
      this.currentLetter = 0;
      this.spellingPhrase = '';
      this.letters = [];
      if (!this.isRapidTest) {
        this.quizPhraseCurrent = LearningTools.generateQuizSpellingData(this.$store,
          this.quizPhrase.phrase!);
      }
      this.setupWord();
      this.letterPenalty = Math.round(100 / this.quizPhraseCurrent.phraseAnswer.length);
      (this.$refs.activity as any).startPlaying();
    },
    onActivityStopped() {
      this.currentLetter = 0;
      this.spellingPhrase = '';
      this.letters = [];
    },
    audioPlayed() {
      if (this.wordCompleted) {
        this.$emit('checkQuizEndOrNext', this.nextQuestionResponse);
      }
    },
    async onLetter(n: number) {
      if (!this.letters[n - 1].clicked) {
        let answerCorrect = this.quizPhraseCurrent.phraseAnswer[this.currentLetter]
          === this.letters[n - 1].text;

        if (this.isRapidTest) {
          this.lockInput = true;
          this.nextQuestionResponse = await LearningTools.setAnswerAndGetNextRapidTestPhrase(
            this.$store,
            this.$router,
            this.quizPhrase.quizType,
            this.letters[n - 1].text,
          );
          if (!this.nextQuestionResponse) {
            return;
          }
          answerCorrect = this.nextQuestionResponse.next
            || this.nextQuestionResponse.data?.question;
          this.lockInput = false;
        }

        if (answerCorrect) {
          // correct
          this.letters[n - 1].clicked = true;
          this.currentLetter += 1;
          this.rapidTestQuizAnswer.push(this.letters[n - 1].text);
          if (this.wordCompleted) {
            this.$emit('onScoreResult', this.currentScore / 100);
            (this.$refs.activityStatus as any).updateScore(1, '');
            this.spellingPhrase = LearningTools.getWordOrPhonetic(this.$store,
              this.quizPhraseCurrent!.phrase!);
            await BbTools.sleepCancelable(LearningTools.TO_START_PLAYING, this.$store);
            (this.$refs.activity as any).startPlaying();
          }
        } else {
          // incorrect
          const incorrectLetter = this.letters[n - 1];
          incorrectLetter.badge = true;
          (this.$refs.activityStatus as any).updateScore(0, '');
          this.currentScore -= this.letterPenalty;
          if (this.currentScore < 0) {
            this.currentScore = 0;
          }
          setTimeout(() => { incorrectLetter.badge = false; }, 500);
        }
      }
    },
    quizAnswer(n: number) {
      if (n < this.currentLetter) {
        if (this.isRapidTest) {
          return this.rapidTestQuizAnswer[n];
        }
        return this.quizPhraseCurrent.phraseAnswer[n];
      }
      return this.$vuetify.breakpoint.xs ? '_' : '__';
    },
    quizAnswerClass(n: number) {
      if (n < this.currentLetter) {
        return 'success--text';
      }
      return 'white--text';
    },
    setupWord() {
      this.spellingPhrase = this.quizPhraseCurrent.wordWithoutSpelling;
      const letters = new Array<QuizSpellingLetter>();
      this.quizPhraseCurrent.choicesString.forEach((letter: string) => {
        letters.push({
          text: letter,
          clicked: false,
          badge: false,
        } as QuizSpellingLetter);
      });
      this.letters = letters;
    },
  },
  beforeDestroy() {
    if (this.$store.state.sleepPromise) {
      this.$store.state.sleepPromise.cancel();
    }
  },
});
